import { render } from "./JobMappingTab.vue?vue&type=template&id=5fe6a63e&scoped=true"
import script from "./JobMappingTab.vue?vue&type=script&lang=js"
export * from "./JobMappingTab.vue?vue&type=script&lang=js"

import "./JobMappingTab.vue?vue&type=style&index=0&id=5fe6a63e&scoped=true&lang=css"
import "./JobMappingTab.vue?vue&type=style&index=1&id=5fe6a63e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe6a63e"]])

export default __exports__